const HEX_RE = /^#([0-9A-F]{3}){1,2}$/i

export const isHex = (color: string) => HEX_RE.test(color)
